import styled, { keyframes } from "styled-components";

const enterKeyframes = keyframes`
  0% {
    transform: translateX(0px) translateY(20px) scale(1) rotate(0deg) skewX(0deg) skewY(0deg);
    opacity: 0.01;
    filter: blur(6px);
  }
  100% {
    transform: none;
    opacity: 1;
    filter: blur(0);
  }
    
`;
export const ButtonComponentHolderMainDiv = styled.div`
  width: 100%;
  flex: 1;
  text-align: center;
  animation: ${enterKeyframes} ease-in 0.6s;

  > a {
    border-radius: var(--size-1);
    padding: 12px 20px;
    display: flex;
    gap: 8px;
    text-decoration: none;
  }

  .circle {
    background: radial-gradient(
      50% 50% at 50% 50%,
      rgb(255, 255, 255) 52.88461446762085%,
      rgb(140, 87, 10) 100%
    );
    filter: blur(3px);
    -webkit-filter: blur(3px);
    border-radius: 100%;
    height: 47px;
    transform-origin: 50% 50% 0px;
    position: absolute;
    top: -4px;
    left: 9px;
    right: 9px;
  }
  .top-blur {
    background: rgb(216, 135, 54);
    border-radius: 100%;
    filter: blur(10px);
    -webkit-filter: blur(10px);
    opacity: 0.5;
    height: var(--size-1);
    z-index: 2;
    position: absolute;
    top: 1px;
    left: 0;
    right: 0;
  }
  .radial-gradient {
    background: linear-gradient(
  163deg,
  rgb(255, 223, 125) 28%,   /* The Base: Warm Gold */
  rgb(161, 115, 69) 54%,    /* The Shadow: Deep Bronze/Brown */
  rgba(21, 21, 21, 1) 68%,         /* The Void: Pure Black */
  rgb(97, 150, 242) 100%    /* The Pop: Cornflower Blue */
);

    border-radius: var(--size-1);
    z-index: 1;
    position: absolute;
    inset: 0;
  }
  .inset {
    background: var(--main-bg);
    border-radius: var(--size-1);
    z-index: 1;
    inset: 2px;
    position: absolute;
  }
  .button-holder {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 0;
    width: 100%;
    padding: 0;
    overflow: hidden;
    height: 26px;
  }
  .button-label,
  .button-label-2 {
    white-space: nowrap;
    transition: all 0.4s;
    will-change: transform;

    z-index: 1;
    transform: none;
    display: flex;
    flex-direction: row;
    align-items: center;

    gap: 4px;
  }
  .button-label-2 {
    opacity: 0;
  }

  .button-label-text {
    padding: 4px 0;
    margin: 0;
    text-transform: capitalize;
    text-decoration: none;
    font-size: 16px;
    line-height: 1.2em;
    font-weight: 500;
  }
  &:hover {
    .button-label-2,
    .button-label {
      transform: translateY(-27px);
    }
    .button-label-2 {
      opacity: 1;
    }
    .button-label {
      opacity: 0;
    }
  }
`;

export const ButtonVariantComponentHolderMainDiv = styled.div`
  flex: 1;
  width: 100%;
  text-align: center;
  animation: ${enterKeyframes} ease-in 1s;

  > a {
    border-radius: var(--size-1);
    padding: 12px 20px;
    display: flex;
    gap: 8px;
    text-decoration: none;
  }

  .circle {
    filter: blur(3px);
    -webkit-filter: blur(3px);
    border-radius: 100%;
    height: 47px;
    transform-origin: 50% 50% 0px;
    position: absolute;
    top: -4px;
    left: 9px;
    right: 9px;
  }
  .top-blur {
    border-radius: 100%;
    filter: blur(10px);
    -webkit-filter: blur(10px);
    opacity: 0.5;
    height: var(--size-1);
    z-index: 2;
    position: absolute;
    top: 1px;
    left: 0;
    right: 0;
  }
  .radial-gradient {
    background: rgb(255 255 255 / 20%);

    border-radius: var(--size-1);
    z-index: 1;
    position: absolute;
    inset: 0;
  }
  .inset {
    background: var(--main-bg);
    border-radius: var(--size-1);
    z-index: 1;
    inset: 1px;
    position: absolute;
  }
  .button-holder {
    display: flex;
    flex-direction: column;
    flex: 1;

    align-items: center;
    gap: 0;
    width: 100%;
    padding: 0;
    overflow: hidden;
    height: 26px;
  }
  .button-label,
  .button-label-2 {
    white-space: nowrap;
    transition: all 0.4s;
    will-change: transform;

    z-index: 1;
    transform: none;
    display: flex;
    flex-direction: column;
  }
  .button-label-2 {
    opacity: 0;
  }

  .button-label-text {
    padding: 4px 0;
    margin: 0;
    text-transform: capitalize;
    text-decoration: none;
    font-size: 16px;
    line-height: 1.2em;
    font-weight: 500;
  }
  &:hover {
    .button-label-2,
    .button-label {
      transform: translateY(-27px);
    }
    .button-label-2 {
      opacity: 1;
    }
    .button-label {
      opacity: 0;
    }
  }
`;
